import React from 'react';
import { Route } from "react-router-dom";
import StatisticsView from './statistics.view';


const StatisticsRouter = ({ match }) => (
  <div>
    <Route
      path={match.path}
      component={StatisticsView}
    />
  </div>
);

export default StatisticsRouter;
